module.exports = __webpack_public_path__ + "images/image-placeholder.46365f90.png";